// API Configuration
//
// Resolution order:
//   1. REACT_APP_API_URL           - set in .env / .env.production, or at build time:
//                                    REACT_APP_API_URL=https://api.example.com npm run build
//   2. production default          - the deployed backend
//   3. development default         - local backend on port 5000
//
// Keep the production default in sync with whatever backend the site is
// actually deployed against; REACT_APP_API_URL always wins when set.
// Matches frontend/.env.production, which is what the deployed site is built with.
const PRODUCTION_API_URL = 'https://siddhivinayak-api.187.77.146.110.nip.io';
const DEVELOPMENT_API_URL = 'http://localhost:5000';

const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? PRODUCTION_API_URL : DEVELOPMENT_API_URL);

export default API_URL;
